<template>
  <v-toolbar class="primary mainToolbar elevation-0" light>
    <v-toolbar-items style="width: 100% !important">
      <v-btn color="secondary" :ripple="false" flat style="cursor: pointer" class="title" @click="$router.push({ path: '/home' })">
        <img style="height: 30px" src="@/assets/yakshof.png"/>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn style="text-transform: capitalize" color="secondary" :ripple="false" flat @click="$router.push({ path: '/home' })" v-if="isLoggedIn">Home</v-btn>
      <v-btn style="text-transform: capitalize" color="secondary" :ripple="false" flat @click="$router.push({ path: '/market' })">Browse Projects</v-btn>
      <v-btn style="text-transform: capitalize" color="secondary" :ripple="false" flat @click="$router.push({ path: '/diy' })">Create A Project</v-btn>
      <v-btn style="text-transform: capitalize" color="secondary" :ripple="false" flat v-if="!isLoggedIn" @click="goToDemo()">Free Demo</v-btn>
      <v-btn style="text-transform: capitalize" color="secondary" :ripple="false" flat v-if="isLoggedIn && isAdmin" @click="$router.push({ path: '/organization/users' })">
        <v-layout>
          <div>Organization</div>
          <div v-if="requestsCount > 0" style="background-color: #213EFF; color: white; border-radius: 100%; font-size: 14px; font-weight: 700; width: 24px; height: 24px; margin-left: 10px; display: flex; align-items: center; justify-content: center"> {{ requestsCount }}</div>
        </v-layout>
      </v-btn>
      <v-btn style="text-transform: capitalize" color="secondary" :ripple="false" flat v-if="isLoggedIn && this.getRoleByName('MASTER_ROLE') && Number(this.getRoleByName('MASTER_ROLE').id) === Number(this.currentUser.defaultRoleId)" @click="$router.push({ path: '/admin/organizations' })">Admin</v-btn>
      <!-- <v-btn style="text-transform: capitalize" color="secondary" :ripple="false" flat v-if="isLoggedIn" @click="$router.push({ path: '/contact' })">Contact Us</v-btn> -->
      <!-- <v-btn style="text-transform: capitalize" color="secondary" :ripple="false" flat v-if="isLoggedIn" @click="$router.push({ path: '/about' })">About Us</v-btn> -->
      <v-spacer v-if="isLoggedIn"></v-spacer>
      <v-btn style="text-transform: capitalize; padding-left: 25px;" v-if="!isLoggedIn" :ripple="false" flat @click="goToLogin()" color="secondary" class="loginButton">Login</v-btn>
      <v-menu offset-y v-else-if="isLoggedIn && getUserOrganization && getUserOrganization.name" :close-on-content-click="true" style="padding-left: 25px;">
        <div class="secondary--text" slot="activator">
          <v-layout row>
            <div>
              <span style="font-size: 18px; font-weight: 700">{{this.getUserOrganization ? this.getUserOrganization.name : ''}}</span><br><span style="font-size: 18px">{{this.currentUser.firstName + ' ' + this.currentUser.lastName}}</span>
            </div>
            <div style="display: flex; align-items: center; justify-content: flex-end; width: 40px"><img src="@/assets/openMenu.png" style="max-width: 14px"/></div>
          </v-layout>
        </div>
        <v-list style="border-radius: 10px" class="userMenuList mt-2">
          <v-list-tile @click="$router.push('/settings/profile')">
            <v-list-tile-title>Edit Profile</v-list-tile-title>
          </v-list-tile>
          <!-- <v-list-tile @click="$router.push('/organization')">
            <v-list-tile-title>Saved Projects</v-list-tile-title>
          </v-list-tile> -->
          <v-list-tile @click="$router.push('/settings/notifications')">
            <v-list-tile-title>Notifications</v-list-tile-title>
          </v-list-tile>
          <v-divider></v-divider>
          <v-list-tile v-if="getOrganizations.length > 1" class="noHover">
            <v-list-tile-title style="font-size: 12px">Switch to</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="getOrganizationData(item.id)" v-if="getOrganizations.length > 1" v-for="item in getOrganizations" :key="item.id">
            <v-list-tile-title style="font-weight: 700">{{item.name}}</v-list-tile-title>
          </v-list-tile>
          <v-divider v-if="getOrganizations.length > 1"></v-divider>
          <v-list-tile @click="logout">
            <v-list-tile-title>Log out</v-list-tile-title>
          </v-list-tile>
         </v-list>
      </v-menu>
    </v-toolbar-items>
  </v-toolbar>
</template>

<style>
  .userMenuList .v-list__tile:hover{
    background-color: #2165FF !important;
    color: white !important;
    transition: none;
  }
  .userMenuList .noHover .v-list__tile:hover{
    background-color: transparent !important;
    color: #011E41 !important;
  }
  .userMenuList .v-list__tile{
    transition: none;
    height: 30px;
    color: #011E41
  }
  .userMenuList .v-list__tile__title{
    font-size: 14px;
  }
  .v-menu__content{
    border-radius: 10px
  }
  .mainToolbar .v-toolbar__content{
    padding-right: 5%;
    padding-left: 5%;
    height: 100px !important
  }
  .mainToolbar{
    font-family: 'Open Sans';
    font-weight: 300;
    font-size: 18px;
  }
  .mainToolbar button:before{
    content: none;
  }
  .loginButton{
    height: auto !important;
  }
  .loginButton .v-btn__content{
    border: 1px solid;
    border-radius: 50px;
    padding: 0px 50px;
    height: 35px;
    width: 40px;
  }
</style>

<script>
import Login from '../Login.vue'
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  props: {
    options: {
      type: Object,
      default: () => ({})
    },
    loginDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'currentUser']),
    ...mapGetters({getRoleByName: 'getRoleByName', getUserOrganization: 'getUserOrganization', getOrganizations: 'getOrganizations'}),
    isBillingUser () {
      return this.isLoggedIn && this.getUserOrganization
    },
    isAdmin () {
      return this.isLoggedIn && this.getUserOrganization && this.getUserOrganization.organizationUsers && this.getUserOrganization.organizationUsers.find(item => { return item.userId === this.currentUser.id }) && this.getRoleByName('VIEWER_ROLE') && this.getUserOrganization.organizationUsers.find(item => { return item.userId === this.currentUser.id }).roleId !== this.getRoleByName('VIEWER_ROLE').id
    },
    requestsCount () {
      if (!this.getUserOrganization || !this.getUserOrganization.organizationProjects || !this.getUserOrganization.organizationUserProjects) {
        return 0
      }
      var i = 0
      var j = 0
      var accessRequests = []
      var tempaccessRequests = this.getUserOrganization.organizationUserProjects.filter(item => {
        return !item.status.toLowerCase().includes('active') && !item.status.toLowerCase().includes('user') && !item.status.toLowerCase().includes('external') && Number(item.userId) !== Number(this.currentUser.id)
      })
      for (i = 0; i < tempaccessRequests.length; i++) {
        for (j = 0; j < this.getUserOrganization.organizationProjects.length; j++) {
          if (Number(tempaccessRequests[i].projectId) === Number(this.getUserOrganization.organizationProjects[j].projectId) && this.getUserOrganization.organizationProjects[j].status.toLowerCase().includes('active')) {
            accessRequests.push(tempaccessRequests[i])
            break
          }
        }
      }

      var subscriptionRequests = []
      var tempSubscriptionRequests = this.getUserOrganization.organizationUserProjects.filter(item => {
        return !item.status.toLowerCase().includes('active') && !item.status.toLowerCase().includes('external') && Number(item.userId) !== Number(this.currentUser.id)
      })
      for (i = 0; i < tempSubscriptionRequests.length; i++) {
        for (j = 0; j < this.getUserOrganization.organizationProjects.length; j++) {
          if (Number(tempSubscriptionRequests[i].projectId) === Number(this.getUserOrganization.organizationProjects[j].projectId) && this.getUserOrganization.organizationProjects[j].type.toLowerCase() === 'subscription' && !this.getUserOrganization.organizationProjects[j].status.toLowerCase().includes('active')) {
            subscriptionRequests.push(tempSubscriptionRequests[i])
            break
          }
        }
      }

      var projectRequests = []
      var tempProjectRequests = this.getUserOrganization.organizationUserProjects.filter(item => {
        return !item.status.toLowerCase().includes('active') && !item.status.toLowerCase().includes('external') && Number(item.userId) !== Number(this.currentUser.id)
      })
      for (i = 0; i < tempProjectRequests.length; i++) {
        for (j = 0; j < this.getUserOrganization.organizationProjects.length; j++) {
          if (Number(tempProjectRequests[i].projectId) === Number(this.getUserOrganization.organizationProjects[j].projectId) && this.getUserOrganization.organizationProjects[j].type.toLowerCase() === 'diy' && !this.getUserOrganization.organizationProjects[j].status.toLowerCase().includes('active') && this.getUserOrganization.users.find(user => { return Number(user.id) === Number(tempProjectRequests[i].userId) }).active) {
            projectRequests.push(tempProjectRequests[i])
            break
          }
        }
      }

      return accessRequests.length + subscriptionRequests.length + projectRequests.length
    }
  },
  methods: {
    getOrganizationData (id) {
      axios.all([this.$store.dispatch('getOrganizationsWithAllById', {id: id})]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.$store.commit('setUserOrganization', response.data.payload)
        } else {
          this.notify({message: 'Something went wrong.', show: true})
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    goToDemo () {
      window.open('https://app.dataslicer.io/#/demo', '_blank')
    },
    async logout () {
      this.$router.push({ path: '/home' })
      this.$store.dispatch('auth/logout')
      this.$cookie.delete('ykx-v2-cookie-jwt-token', {domain: (process.env.NODE_ENV === 'production' ? 'dataslicer.io' : 'localhost')})
      this.$cookie.delete('ykx-v2-cookie-jwt-user', {domain: (process.env.NODE_ENV === 'production' ? 'dataslicer.io' : 'localhost')})
      this.$store.commit('resetState')
    },
    goToLogin () {
      if (this.$route.path !== '/signup') {
        this.$router.push({ path: '/login', query: { path: this.$route.path } })
      } else {
        this.$router.push('/login')
      }
    }
  },
  components: {
    Login
  },
  watch: {
    loginDialog: function (newVal, oldVal) {
      this.loginDialog = newVal
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/appElements/MainToolbar.vue